import { useEffect, useState } from 'react';
import { bindActionCreators, Dispatch } from '@reduxjs/toolkit';
import { connect } from 'react-redux';

import Toast from 'carbon-react/lib/components/toast';

import { ReduxState } from '../../types/redux/state';
import Translate from '../Translate/Translate';
import { config } from '../../config/env';
import { selectHideBrowserWarning } from '../../redux/selectors';

import * as generalActions from '../../redux/General/actions';

// Check if the Opera browser is Opera Mini or Opera Mobile in regular mode (called High Savings Mode)
const isOperaMiniHigh =
  navigator.userAgent.indexOf('OPR/') > -1 && navigator.userAgent.indexOf('Mobile') > -1 && navigator.userAgent.indexOf('Presto/') < 0;
// Check if the Opera browser is Opera Mini in Extreme Savings Mode
const isOperaMiniExtreme = navigator.userAgent.indexOf('Opera Mini/') > -1 && navigator.userAgent.indexOf('Presto/') > -1;

const isOperaMini = isOperaMiniHigh || isOperaMiniExtreme;

const isIE = () => {
  const ua = navigator.userAgent; //Check the userAgent property of the window.navigator object
  const msie = ua.indexOf('MSIE '); // IE 10 or older
  const trident = ua.indexOf('Trident/'); //IE 11

  return msie > -1 || trident > -1;
};
const isBrowserUnsupported = isOperaMini || isIE();

type UnsupportedBrowserProps = { dismissBrowserWarning: () => void; hideBrowserWarning: boolean };

const UnsupportedBrowser = ({ dismissBrowserWarning, hideBrowserWarning }: UnsupportedBrowserProps) => {
  const [notSupported, setNotSupported] = useState(false);

  useEffect(() => {
    if (isBrowserUnsupported && !hideBrowserWarning) {
      setNotSupported(true);
    } else {
      setNotSupported(false);
    }
  }, [setNotSupported, hideBrowserWarning]);

  const onDismiss = () => {
    setNotSupported(false);
    dismissBrowserWarning();
  };

  if (notSupported) {
    return (
      <Toast variant="warning" id="unsupported-browser-toast" open={notSupported} onDismiss={onDismiss} maxWidth="1300">
        <p>
          <strong>
            <Translate scope="BrowserRequirements" />
          </strong>
        </p>
        <p>
          <Translate scope="Unsupportedbrowserversion1" />
          <a href={config.REACT_APP_SUPPORTED_BROWSERS_LINK} target="_blank" rel="noopener noreferrer">
            <Translate scope="Clickhere" />
          </a>
          <Translate scope="Unsupportedbrowserversion2" />
        </p>
      </Toast>
    );
  }
  return null;
};

const mapStateToProps = (state: ReduxState) => ({
  hideBrowserWarning: selectHideBrowserWarning(state),
});

const mapDispatch = (dispatch: Dispatch) => {
  const _general = bindActionCreators(generalActions, dispatch);
  return {
    dismissBrowserWarning: _general.dismissBrowserWarning,
  };
};

export default connect(mapStateToProps, mapDispatch)(UnsupportedBrowser);
